export default __webpack_public_path__ + "static/media/easybank.3727187a.webp";